/*
 * @Author: zhangyanqiang zhangyanqiang@u-road.com
 * @Date: 2022-05-25 15:08:47
 * @LastEditors: zhangyanqiang zhangyanqiang@u-road.com
 * @LastEditTime: 2022-09-30 13:24:13
 * @FilePath: \githubd:\工作代码\sessionSVGVue\src\api\config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Created by zcr on 2018/1/25.
 */
module.exports = {
    // appid: 'wx2f8a45fb377b2d1c',
    // base_path: 'http://liaoningstapi.u-road.com/LiaoNingHXAPIServer/index.php?/', //
    // base_path: 'https://liaoningstapi.u-road.com/LiaoningGSTAPIServer/www/sessionSVGVue/index.html', //
    base_path: 'https://ystest.ln-gst.com/LiaoningGSTTestAPIServer/www/sessionSVGVue/index.html', //验收环境
    // base_path: 'https://liaoningstapi.u-road.com/LiaoningGSTTestAPIServer/www/sessionSVGVueTest/index.html', //
    // root: 'http://10.1.1.9/GuangxiczAdmin/index.php/api/WX/', // 配置API接口地址
    root: process.env.BASE_URL, // 配置API接口地址
    fwqRoot: process.env.FWQ_BASE_URL // 配置服务API接口地址    

}



// WEBPACK FOOTER //
// ./src/api/config.js